import { ApplicationRootState } from 'store/types';

const selectBackOfficeDevice = (state: ApplicationRootState) =>
  state.backOfficeDevice;

export default selectBackOfficeDevice;
